import { DeviceType } from '~/services/api/enums';
import { IFormValues } from '../types';

const initialValues: IFormValues = {
  deviceId: null,
  typeId: DeviceType.BloodPressure,
};

export default initialValues;
